var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout--full-page"},[_c('front-header'),_c('router-view'),_c('front-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }